module.exports = __webpack_public_path__ + "d95d6f5d5ab7cfefd09651800b69bd54.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/font-awesome/fonts/fontawesome-webfont.woff?v=4.0.3
 ** module id = 343
 ** module chunks = 0
 **/